import { render, staticRenderFns } from "./GoodsGroupManagement.vue?vue&type=template&id=4e50ed57&scoped=true"
import script from "./GoodsGroupManagement.vue?vue&type=script&lang=js"
export * from "./GoodsGroupManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e50ed57",
  null
  
)

export default component.exports